<template>
  <div class="">
    <Upload @ReceiveEvent="ReceiveParams"></Upload>
  </div>
</template>
<script>
  import Upload from '@/components/upload.vue'
  export default {
    name: '',
    data(){
      return {

      }
    },
    components: {
      Upload
    },
    computed:{

    },
    methods:{
      ReceiveParams(params){
        params.name = "wozaiqiye";
        this.Submit(params)
      },
      Submit(postData){
        this.$http.post("/inqiye/SavePageDetail",postData).then((res)=>{
          this.$message.success('提交成功');
        }).catch((err)=>{

        })
      },
    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style scoped>

</style>
